var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeContactIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 3.33337C10.8842 3.33337 11.7321 3.68456 12.3572 4.30968C12.9823 4.93481 13.3335 5.78265 13.3335 6.66671C13.3335 7.55076 12.9823 8.39861 12.3572 9.02373C11.7321 9.64885 10.8842 10 10.0002 10C9.11611 10 8.26826 9.64885 7.64314 9.02373C7.01802 8.39861 6.66683 7.55076 6.66683 6.66671C6.66683 5.78265 7.01802 4.93481 7.64314 4.30968C8.26826 3.68456 9.11611 3.33337 10.0002 3.33337ZM10.0002 11.6667C13.6835 11.6667 16.6668 13.1584 16.6668 15V16.6667H3.3335V15C3.3335 13.1584 6.31683 11.6667 10.0002 11.6667Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeContactIcon);
export default __webpack_public_path__ + "static/media/change-contact-icon.1cf0e0978c42a7a63fc3d21892048c66.svg";
export { ForwardRef as ReactComponent };